/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved */
import * as RNWeb from 'react-native-web';

// ts-prune-ignore-next
export const TurboModuleRegistry = {
    get: () => null,
    getEnforcing: () => {
        throw new Error('TurboModuleRegistry is not available on web');
    },
};

// ts-prune-ignore-next
export const PermissionsAndroid = {
    check: async () => false,
    request: async () => 'denied',
    PERMISSIONS: { CAMERA: 'camera' },
    RESULTS: { GRANTED: 'granted', DENIED: 'denied' },
};

// ts-prune-ignore-next
export const ActionSheetIOS = {
    showActionSheetWithOptions: (_opts: unknown, cb?: (idx: number)=> void) => cb?.(0),
};

export * from 'react-native-web';

// ts-prune-ignore-next
const defaultExport = {
    ...RNWeb,
    PermissionsAndroid,
    ActionSheetIOS,
    TurboModuleRegistry,
};

export default defaultExport;
